import { MessageCircle, Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { FadeIn } from "./FadeIn";
import { SITE } from "@/lib/site";

export const Footer = () => {
  return (
    <footer
      id="contact"
      data-testid="footer-section"
      className="relative bg-brand-primary text-brand-base overflow-hidden"
    >
      <div className="absolute inset-0 -z-0 opacity-[0.04]">
        <div className="absolute -top-24 -left-24 h-96 w-96 rounded-full bg-brand-accent blur-3xl" />
        <div className="absolute bottom-0 right-0 h-96 w-96 rounded-full bg-brand-secondary blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 pt-24 sm:pt-32 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-7">
            <FadeIn>
              <p className="text-xs sm:text-sm uppercase tracking-[0.3em] text-brand-accent font-semibold mb-6">
                Contact
              </p>
            </FadeIn>
            <FadeIn delay={0.1}>
              <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.95]">
                Let's talk
                <br />
                <span className="italic text-brand-secondary">mangoes.</span>
              </h2>
            </FadeIn>
            <FadeIn delay={0.2}>
              <p className="mt-8 text-brand-base/70 text-base sm:text-lg max-w-xl leading-relaxed">
                Bulk orders, corporate gifting, single-box retail — reach out
                and we'll tailor a harvest for you.
              </p>
            </FadeIn>
            <FadeIn delay={0.3}>
              <a
                href={SITE.whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-btn"
                className="mt-10 inline-flex items-center gap-3 rounded-full bg-brand-base text-brand-primary px-8 py-4 text-sm font-medium transition-all duration-300 hover:-translate-y-0.5 hover:bg-white"
              >
                <MessageCircle size={18} strokeWidth={1.8} />
                Chat on WhatsApp
                <ArrowUpRight size={16} />
              </a>
            </FadeIn>
          </div>

          <div className="lg:col-span-5">
            <FadeIn delay={0.3}>
              <div className="space-y-6 lg:border-l lg:border-white/10 lg:pl-12">
                <div className="flex items-start gap-4">
                  <Phone
                    size={18}
                    strokeWidth={1.5}
                    className="mt-1 text-brand-secondary"
                  />
                  <div>
                    <div className="text-xs uppercase tracking-[0.25em] text-brand-base/60">
                      Phone
                    </div>
                    <a
                      href={`tel:${SITE.phoneRaw}`}
                      data-testid="footer-phone"
                      className="font-display text-xl mt-1 block hover:text-brand-secondary transition-colors"
                    >
                      {SITE.phone}
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <Mail
                    size={18}
                    strokeWidth={1.5}
                    className="mt-1 text-brand-secondary"
                  />
                  <div>
                    <div className="text-xs uppercase tracking-[0.25em] text-brand-base/60">
                      Email
                    </div>
                    <a
                      href={`mailto:${SITE.email}`}
                      data-testid="footer-email"
                      className="font-display text-xl mt-1 block hover:text-brand-secondary transition-colors break-all"
                    >
                      {SITE.email}
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <MapPin
                    size={18}
                    strokeWidth={1.5}
                    className="mt-1 text-brand-secondary"
                  />
                  <div>
                    <div className="text-xs uppercase tracking-[0.25em] text-brand-base/60">
                      Based in
                    </div>
                    <div
                      data-testid="footer-address"
                      className="font-display text-xl mt-1"
                    >
                      {SITE.address}
                    </div>
                  </div>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-brand-base/50">
          <div>
            © {new Date().getFullYear()} {SITE.brand}. All rights reserved.
          </div>
          <div className="flex items-center gap-6">
            <span>Crafted with care in Gujarat.</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
